import { Alert, Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type TimeoffCompensationForm from 'modules/timeoff/lib/TimeoffCompensationForm'

import CompensationCapacity from './CompensationCapacity'
import NegativeBalance from './NegativeBalance'
import SelectFrequency from './SelectFrequency'
import SelectThreshold from './SelectThreshold'
import Threshold from './Threshold'

interface CardContentProps {
  form: TimeoffCompensationForm
  shouldUpdateBalanceReset: boolean
}

const CardContent = ({ form, shouldUpdateBalanceReset }: CardContentProps) => {
  const thresholdEnabled = form.get('has_threshold_enabled')
  const hasUnlimitedCompensation = form.get('has_unlimited_compensation')
  const thresholdCapacity = form.get('threshold_capacity')

  const thresholdValid = !!thresholdEnabled.value ? thresholdCapacity.value >= 0 : true
  const showSubmitButton = form.isDirty && thresholdValid

  return (
    <Box paddingX="s8" gap="s24">
      <SelectFrequency form={form} shouldUpdateBalanceReset={shouldUpdateBalanceReset} />
      <SelectThreshold field={form.get('has_threshold_enabled')} />
      <Threshold form={form} />
      <CompensationCapacity form={form} />
      <NegativeBalance form={form} />

      {!hasUnlimitedCompensation.value && (
        <Box flexDirection="row" alignItems="center">
          <Alert color="warning">
            {i18n.t('time_tracking.settings.overtime.compensation.timeoff.form.alert_maximum_time')}
          </Alert>
        </Box>
      )}

      <Box flexDirection="row" justifyContent="flexEnd" alignItems="center">
        {showSubmitButton && <Button submit>{i18n.t('common.save')}</Button>}
      </Box>
    </Box>
  )
}

export default observer(CardContent)
